<script setup>

defineProps({
  match: {
    required: true,
    type: Object,
  },
})
</script>

<template>
  <div class="p-3">
    <div class="grid grid-cols-7 items-center gap-2">
      <!-- Heure -->
      <div class="col-span-1 text-center text-sm text-primary-600 font-medium">
        {{ match.time }}
      </div>

      <!-- Teams -->
      <div
        :class="{
          'col-span-7': !match.isFinished,
          'col-span-6': match.isFinished,
        }"
      >
        <div class="space-y-1">
          <!-- Team 1 -->
          <div
            class="flex overflow-hidden gap-2 items-center"
            v-for="(team, teamIndex) in [match.team1, match.team2]"
            :key="teamIndex"
          >
            <div class="w-5 h-5 min-w-5">
              <ImgComponent
                :src="team.logo"
                fallback="/images/match/t-shirt.svg"
                class="w-full h-full"
                alt=""
              />
            </div>
            <div class="truncate w-full font-medium text-primary-800">
              {{ team.name }}
            </div>
            <div class="w-6 min-w-6 text-right font-bold text-primary-900">
              {{ team.score ?? '-' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Quotes (cotes) -->
      <div class="col-span-3 grid grid-cols-3 gap-1" v-if="!match.isFinished">
        <div
          v-for="quoteId in [
            { name: '1', id: '1' },
            { name: 'X', id: 'X' },
            { name: '2', id: '2' },
          ]"
          :key="quoteId.name"
          class="hidden! flex flex-col items-center justify-center py-2 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <div class="text-xs font-medium text-primary-600">
            {{ quoteId.name }}
          </div>
          <div class="font-bold text-sm text-primary-900">
            {{ (match.quotes && match.quotes[quoteId.id]) || '-' }}
          </div>
        </div>
      </div>

      <!-- Match terminé -->
      <div
        v-else
        class="col-span-3 text-center text-sm font-medium"
        :class="{
          'text-green-600':
            match.team1.score > match.team2.score ||
            match.team2.score > match.team1.score,
        }"
      >
        Match terminé
      </div>
    </div>
  </div>
</template>
